import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const SuccessConfirmationModal = ({
    isOpen,
    closeBehavior,
    successResponse,
}) => {
    return (
        <Modal className="text-light" centered isOpen={isOpen}>
            <ModalHeader>
                {successResponse?.isSuccess ? 'Success!' : 'Failed!'}
            </ModalHeader>
            <ModalBody>
                <p>{successResponse?.message}</p>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => closeBehavior()}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SuccessConfirmationModal;
